/** The slowest and the quickest a screenshot glides top to bottom, in seconds. */
export const GLIDE_MIN_S = 5;
export const GLIDE_MAX_S = 12;
/** How far it moves each second: a taller page takes longer, so every page moves at a readable pace. */
const GLIDE_PX_PER_S = 110;

/** How far a picture has to move to show all of it in a window. */
export function glideTravel(pictureHeight: number, windowHeight: number): number {
  return Math.max(0, Math.round(pictureHeight - windowHeight));
}

/** How long the glide takes for that distance, kept between the slowest and the quickest. */
export function glideSeconds(travel: number): number {
  return Math.min(GLIDE_MAX_S, Math.max(GLIDE_MIN_S, travel / GLIDE_PX_PER_S));
}
